export class OpenDialog {
  static readonly type = '[Help button] Open dialog';

  constructor(public title: string, public content: string) { }
}

export class CloseDialog {
  static readonly type = '[Help button] Close dialog';
}
